import mixpanel from "mixpanel-browser";
import { MIXPANEL_TOKEN_ID } from "../redux/apiConfig";
import { getPublicIP } from "./getIp";

export const initMixpanel = () => {
  console.log("MIXPANEL_TOKEN_ID,", MIXPANEL_TOKEN_ID);
  if (!MIXPANEL_TOKEN_ID) return;
  mixpanel.init(MIXPANEL_TOKEN_ID, {
    debug: false,
  });
};
// Login
export const identifyUser = (user) => {
  if (!user?.uiid) return;
  if (!MIXPANEL_TOKEN_ID) return;
  mixpanel.identify(user.uiid);
  const role = user?.role || {};
  const module =
    role?.module === 2
      ? "ATS"
      : role?.module === 3
        ? "WorkForce"
        : role?.module === 4
          ? "Bench Sales"
          : "ATS"; // decide module
  mixpanel.people.set({
    $name: user.firstName + " " + user.lastName,
    $email:user.email,
    $roleName: user?.role?.name,
    $module: user?.role?.module,
    $orgName: user?.organizationId?.name,
  });
  trackEvent({
    eventName: "User Login",
    props: {
      name: user.firstName,
      roleName: user?.role?.name,
      module: user?.role?.module,
      orgName: user?.organizationId?.name,
    },
    product: module,
  });
};
// const fetchIp = async () => {
//   try {
//     const res = await fetch("https://api64.ipify.org?format=json");
//     if (!res.ok) throw new Error("Network error");

//     const data = await res.json();
//     return data?.ip || null;
//   } catch (err) {
//     return null;
//   }
// };
// Generic Event Tracker
export const trackEvent = async ({
  eventName,
  props = {},
  product = "ATS",
}) => {
  // const ip = await fetchIp();
  const ip = await getPublicIP();
  if (!MIXPANEL_TOKEN_ID) return;
  mixpanel.track(eventName, {
    product: product,
    ...props,
    userIp: ip,
  });
};

export default mixpanel;
